/***************************************************************************************
* FileName      : ProduceStats.js
* Description   : 해와관리자 > 통계 > 판매통계 조회 페이지 
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2024.02.20
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import {Row, Col, Button , Navbar, Nav, Container} from 'react-bootstrap';
import Day from "./ProduceStats/Day";
import Month from "./ProduceStats/Month";
import Time from "./ProduceStats/Time";

import React, { useState } from 'react';

function ProduceStats()
{
    const [activeComponent, setActiveComponent] = useState("Month");

    const handleButtonClick = (componentName) => {
      setActiveComponent(componentName);
    };

    return(
        <>
        <div className='mainContents'>
            <div className='page-tit'>
                <h2>판매통계</h2>
            </div>
            <div className='setting-tab-buttons'>
                
                <button className={activeComponent === "Month" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Month")}>월별</button>

                <button className={activeComponent === "Day" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Day")}>일별</button>
          
                <button className={activeComponent === "Time" ? "active-button" : "m-sm-btn w130"}
                        onClick={() => handleButtonClick("Time")}>시간대별</button>

            </div>

            {/* 월별 */}
            {activeComponent === "Month" && <Month />}
            
            {/* 일별 */}
            {activeComponent === "Day" && <Day />}

            {/* 시간대별 */}
            {activeComponent === "Time" && <Time />}


        </div>

        </>
    )
}

export default ProduceStats